import { CreateNetworkProfileIpRange } from '@infuse/api/e-connector/network-profile';

export interface IpRangeListItem extends CreateNetworkProfileIpRange {
  id: number;
  error: boolean;
}

export const toIpRangesWithoutAddedFields = (ipRanges: IpRangeListItem[]): CreateNetworkProfileIpRange[] =>
  ipRanges.map((ir) => {
    return { ipCidrRange: ir.ipCidrRange };
  });
